import { gql } from '@apollo/client';

export default gql`
  mutation AddHotelProduct($currency: Currency!, $newHotelInput: NewHotelInput!, $bookingReference: String!) {
    addHotelProduct(currency: $currency, newHotelInput: $newHotelInput, bookingReference: $bookingReference) {
      reference
      totalPriceToBePaid: totalPriceToBePaidWithCurrency
      hotels(cancelled: false, provisional: true) {
        itemRef
      }
    }
  }
`;
